/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */ 
import CoreService from "../../../../CoreService";
import ServiceFactory from "../../../../../framework/factory/ServiceFactory";
import SalesRuleToPercentService from "./ToPercentService";
import SalesRuleByPercentService from "./ByPercentService";
import SalesRuleToFixedService from "./ToFixedService";
import SalesRuleByFixedService from "./ByFixedService";
import SalesRuleCartFixedService from "./CartFixedService";
import SalesRuleBuyXGetYService from "./BuyXGetYService";
import SimpleActionConstant from "../../../../../view/constant/salesrule/SimpleActionConstant";


export class SalesRuleCalculatorFactoryService extends CoreService {
    static className = 'SalesRuleCalculatorFactoryService';

    calculatorServices = {
        [SimpleActionConstant.TO_PERCENT_ACTION]: SalesRuleToPercentService,
        [SimpleActionConstant.BY_PERCENT_ACTION]: SalesRuleByPercentService,
        [SimpleActionConstant.TO_FIXED_ACTION]: SalesRuleToFixedService,
        [SimpleActionConstant.BY_FIXED_ACTION]: SalesRuleByFixedService,
        [SimpleActionConstant.CART_FIXED_ACTION]: SalesRuleCartFixedService,
        [SimpleActionConstant.BUY_X_GET_Y_ACTION]: SalesRuleBuyXGetYService
    };

    /**
     *
     * @param type
     * @return {*}
     */
    create(type) {
        if(this.calculatorServices.hasOwnProperty(type) && this.calculatorServices[type]) {
            return this.calculatorServices[type];
        }
    }
}


/** @type SalesRuleCalculatorFactoryService */
let salesRuleCalculatorFactoryService = ServiceFactory.get(SalesRuleCalculatorFactoryService);

export default salesRuleCalculatorFactoryService;


// WEBPACK FOOTER //
// ./src/service/salesrule/rule/action/discount/CalculatorFactoryService.js